import { Component, OnInit, Input, Output, EventEmitter, HostListener, inject, ChangeDetectorRef } from '@angular/core';
import {
  IonItem, IonAvatar, IonIcon, IonLabel, IonList, IonButton, IonPopover, IonContent, IonCardSubtitle, IonCardContent,
  IonCard, IonCardHeader, IonCardTitle

} from "@ionic/angular/standalone";
import { AuthService } from 'src/app/core/services/auth.service';
import { Router } from '@angular/router';

export interface DropdownItem {
  label: string;
  icon: string;
  action: string;
  color?: string;
}

@Component({
  selector: 'app-user-dropdown',
  templateUrl: './user-dropdown.component.html',
  styleUrls: ['./user-dropdown.component.scss'],
  imports: [IonCardContent, IonCardSubtitle, IonItem, IonAvatar, IonIcon, IonLabel, IonList, IonButton, IonPopover, IonContent,
    IonCard, IonCardHeader, IonCardTitle

  ]
})
export class UserDropdownComponent implements OnInit {
  private authService = inject(AuthService);
  private router = inject(Router);
  private cdr = inject(ChangeDetectorRef);
  user: any;


  @Input() menuItems: DropdownItem[] = [
    {
      label: 'Mi Perfil',
      icon: 'person-outline',
      action: 'profile'
    },
    {
      label: 'Cerrar Sesión',
      icon: 'log-out-outline',
      action: 'logout'
    }
  ];

  @Output() itemSelected = new EventEmitter<string>();

  userInfo: any;
  isOpen = false;
  constructor() {
    this.user = this.authService.getCurrentUser();
    console.log('Current user:', this.user);
    console.log('UserDropdownComponent initialized');
  }

  ngOnInit() { }

  /* presentPopover(ev: any) {
    this.isOpen = true;
  } */

  onItemClick(item: any) {
    this.isOpen = false;
    switch (item.action) {
      case 'profile':
        this.router.navigate(['/profile']);
        break;
      case 'logout':
        this.authService.logout();
        //this.cdr.markForCheck();
        setTimeout(() => {
          this.router.navigate(['/login']);
        }, 500);

        break;
      default:
        //this.itemSelected.emit(item.action);
        break;
    }
    //cerrar el popover después de seleccionar un elemento

  }

  onPopoverDismiss() { }


}
